import Menu from '../icons/Menu';
import CompanyFreseniusHSVamed from '../../CompanyLogo/logos/CompanyFreseniusHSVamed';
import FreseniusManualLogo from '../../CompanyLogo/logos/CompanyLogoFreseniusManual';
import FreseniusSELogo from '../../CompanyLogo/logos/CompanyLogoFSE';
import CompanyLogoFSEUppercase from '../../CompanyLogo/logos/CompanyLogoFSEUppercase';
import FSEGIJPFooter from '../../CompanyLogo/logos/CompanyLogoGIJPFooter';
import FSEGIJPLarge from '../../CompanyLogo/logos/CompanyLogoGIJPLarge';
import FSEGIJPMobile from '../../CompanyLogo/logos/CompanyLogoGIJPMobile';
import FMCLogo from '../../Logo/logos/FMCLogo';
import FSEBarsLogo from '../../Logo/logos/FSEBarsLogo';
import ArrowCTAAnimationIcon from '../icons/ArrowCTAAnimationIcon';
import DummyIcon from '../icons/DummyIcon';
import ArrowCTAIcon from '../icons/ArrowCTAIcon';
import ArrowDownIcon from '../icons/ArrowDownIcon';
import BackToTopIcon from '../icons/BackToTopIcon';
import BackToTopIconFmc from '../icons/BackToTopIcon_fmc';
import CalendarIcon from '../icons/CalendarIcon';
import CheckIcon from '../icons/CheckIcon';
import CloseIcon from '../icons/CloseIcon';
import ClockIcon from '../icons/ClockIcon';
import ContactPlaceholder from '../icons/ContactPlaceholder';
import ExclamationIcon from '../icons/ExclamationIcon';
import FacebookIcon from '../icons/FacebookIcon';
import KabiLogo from '../../Logo/logos/KabiLogo';
import HamburgerAnimatedIcon from '../icons/HamburgerAnimatedIcon';
import HeartIcon from '../icons/HeartIcon';
import InfoBubbleIcon from '../icons/InfoBubbleIcon';
import InstagramIcon from '../icons/InstagramIcon';
import LanguagesIcon from '../icons/LanguagesIcon';
import LinkedInIcon from '../icons/LinkedInIcon';
import LocationIcon from '../icons/LocationIcon';
import LoginIcon from '../icons/LoginIcon';
import LogoutIcon from '../icons/LogoutIcon';
import MailIcon from '../icons/MailIcon';
import DownloadIcon from '../icons/DownloadIcon';
import NavTogglerSquare from '../icons/NavTogglerSquare';
import PencilIcon from '../icons/PencilIcon';
import PhoneIcon from '../icons/PhoneIcon';
import PrintIcon from '../icons/PrintIcon';
import SearchIcon from '../icons/SearchIcon';
import SmartphoneIcon from '../icons/SmartphoneIcon';
import TargetIcon from '../icons/TargetIcon';
import TranslationIcon from '../icons/TranslationIcon';
import TwitterIcon from '../icons/TwitterIcon';
import WhatsappIcon from '../icons/WhatsappIcon';
import XingIcon from '../icons/XingIcon';
import YoutubeIcon from '../icons/YoutubeIcon';
import DefaultChannel from '../icons/DefaultChannel';
import ArrowIconBold from '../icons/ArrowIconBold';
import BlogIcon from '../icons/BlogIcon';
import BookmarkIcon from '../icons/BookmarkIcon';
import BookmarkHeaderIcon from '../icons/BookmarkHeaderIcon';
import AnimatedSpinnerIcon from '../icons/AnimatedSpinnerIcon';
import Chevron from '../icons/Chevron';
import EnglishFlag from '../icons/flags/EnglishFlag';
import GermanFlag from '../icons/flags/GermanFlag';
import SpanishFlag from '../icons/flags/SpanishFlag';
import ExternalLink from '../icons/ExternalLink';
import Binoculars from '../icons/Binoculars';
import Bell from '../icons/Bell';
import Close from '../icons/Close';
import Crosshairs from '../icons/Crosshairs';
import EnvelopeSimple from '../icons/EnvelopeSimple';
import Funnel from '../icons/Funnel';
import Info from '../icons/Info';
import ListMagnifyingGlass from '../icons/ListMagnifyingGlass';
import Minus from '../icons/Minus';
import Plus from '../icons/Plus';
import Reset from '../icons/Reset';
import Send from '../icons/Send';
import Settings from '../icons/Settings';
import User from '../icons/User';
import World from '../icons/World';
import PauseIcon from '../icons/PauseIcon';
import PlayIcon from '../icons/PlayIcon';

/**
 * @type {IconMapType}
 */
export const IconMap = {
  ARROW_ANIMATION: ArrowCTAAnimationIcon,
  ARROW_BOLD: ArrowIconBold,
  ARROW_CTA: ArrowCTAIcon,
  ARROW_DOWN: ArrowDownIcon,
  BACK_TO_TOP_FMC: BackToTopIconFmc,
  BACK_TO_TOP: BackToTopIcon,
  BELL: Bell,
  BINOCULARS: Binoculars,
  BLOG: BlogIcon,
  BOOKMARK_HEADER: BookmarkHeaderIcon,
  BOOKMARK: BookmarkIcon,
  CALENDAR: CalendarIcon,
  CHECK: CheckIcon,
  CHEVRON: Chevron,
  CLOCK: ClockIcon,
  CLOSE_NEW: Close,
  CLOSE: CloseIcon,
  CONTACTPLACEHOLDER: ContactPlaceholder,
  CROSSHAIRS: Crosshairs,
  DEFAULT: DummyIcon,
  DEFAULTCHANNEL: DefaultChannel,
  DOWNLOAD: DownloadIcon,
  ENGLISH_FLAG: EnglishFlag,
  ENVELOPESIMPLE: EnvelopeSimple,
  EXCLAMATION: ExclamationIcon,
  EXTERNAL_LINK: ExternalLink,
  FACEBOOK: FacebookIcon,
  FMC: FMCLogo,
  FRESENIUS_HEALTH_SERVICES: CompanyFreseniusHSVamed,
  FRESENIUS_MANUAL: FreseniusManualLogo,
  FRESENIUS_SE_UPPERCASE: CompanyLogoFSEUppercase,
  FRESENIUS_SE: FreseniusSELogo,
  FSEBARS: FSEBarsLogo,
  FUNNEL: Funnel,
  GERMAN_FLAG: GermanFlag,
  GIJP_FOOTER: FSEGIJPFooter,
  GIJP_LARGE: FSEGIJPLarge,
  GIJP_MOBILE: FSEGIJPMobile,
  HAMBURGER_ANIMATED: HamburgerAnimatedIcon,
  HEART: HeartIcon,
  INFO: Info,
  INFOBUBBLE: InfoBubbleIcon,
  INSTAGRAM: InstagramIcon,
  KABI: KabiLogo,
  LANGUAGES: LanguagesIcon,
  LINKEDIN: LinkedInIcon,
  LISTMAGNIFYINGGLASS: ListMagnifyingGlass,
  LOCATION: LocationIcon,
  MAIL: MailIcon,
  PENCIL: PencilIcon,
  PHONE: PhoneIcon,
  PRINT: PrintIcon,
  SEARCH: SearchIcon,
  SMARTPHONE: SmartphoneIcon,
  PAUSE: PauseIcon,
  TWITTER: TwitterIcon,
  WHATSAPP: WhatsappIcon,
  XING: XingIcon,
  YOUTUBE: YoutubeIcon,
  NAVTOGGLERSQUARE: NavTogglerSquare,
  LOGIN: LoginIcon,
  LOGOUT: LogoutIcon,
  MENU: Menu,
  MINUS: Minus,
  PLAY: PlayIcon,
  PLUS: Plus,
  RESET: Reset,
  SEND: Send,
  SETTINGS: Settings,
  SPANISH_FLAG: SpanishFlag,
  SPINNER: AnimatedSpinnerIcon,
  TARGET: TargetIcon,
  TRANSLATION: TranslationIcon,
  USER: User,
  WORLD: World,
};
